export const IMMUNIZATION_REASON_OPTIONS = [
  { k: 'standard', v: 'Standard' },
  { k: 'travel', v: 'Travel' },
];

export const VACCINE_CODE_MAP: Record<string, string> = {
  'Adenovirus Vaccine, Type 4, Live, Oral': '54',
  'Adenovirus Vaccine, Type 7, Live, Oral': '55',
  'Adenovirus Vaccine, Unspecified Formulation': '82',
  'Anthrax Vaccine': '24',
  'Bacillus Calmette-Guerin Vaccine': '19',
  'Botulinum Antitoxin': '27',
  'Cholera Vaccine, Unspecified Formulation': '26',
  'Cytomegalovirus Immune Globulin, Intravenous': '29',
  'Dengue Fever Vaccine': '56',
  'Diphtheria Antitoxin': '12',
  'Diphtheria And Tetanus Toxoids, Adsorbed For Pediatric Use': '28',
  'Diphtheria, Tetanus Toxoids And Acellular Pertussis Vaccine': '20',
  'Diphtheria, Tetanus Toxoids And Acellular Pertussis Vaccine, 5 Pertussis Antigens':
    '106',
  'Diphtheria, Tetanus Toxoids And Acellular Pertussis Vaccine, Unspecified Formulation':
    '107',
  'Dtap-Hepatitis B And Poliovirus Vaccine': '110',
  'Dtap-Haemophilus Influenzae Type B Conjugate Vaccine': '50',
  'Diphtheria, Tetanus Toxoids And Acellular Pertussis Vaccine, Haemophilus,Influenzae Type B Conjugate, And Poliovirus Vaccine, Inactivated (Dtap-Hib-Ipv)':
    '120',
  'Diphtheria, Tetanus Toxoids And Acellular Pertussis Vaccine, And Poliovirus Vaccine, Inactivated':
    '130',
  'Diphtheria, Tetanus Toxoids And Pertussis Vaccine': '1',
  'Dtp-Haemophilus Influenzae Type B Conjugate Vaccine': '22',

  'Dtp- Haemophilus Influenzae Type B Conjugate And Hepatitis B Vaccine': '102',
  'Hantavirus Vaccine': '57',
  'Hepatitis A Vaccine, Adult Dosage': '52',

  'Hepatitis A Vaccine, Pediatric/Adolescent Dosage, 2 Dose Schedule': '83',
  'Hepatitis A Vaccine, Pediatric/Adolescent Dosage, 3 Dose Schedule': '84',

  'Hepatitis A Vaccine, Pediatric Dosage, Unspecified Formulation': '31',

  'Hepatitis A Vaccine, Unspecified Formulation': '85',
  'Hepatitis A And Hepatitis B Vaccine': '104',
  'Hepatitis B Immune Globulin': '30',
  'Hepatitis B Vaccine, Pediatric Or Pediatric/Adolescent Dosage': '8',
  'Hepatitis B Vaccine, Adolescent/High Risk Infant Dosage': '42',

  'Hepatitis B Vaccine, Adult Dosage': '43',

  'Hepatitis B Vaccine, Dialysis Patient Dosage': '44',
  'Hepatitis B Vaccine, Unspecified Formulation': '45',
  'Hepatitis C Vaccine': '58',
  'Hepatitis E Vaccine': '59',

  'Herpes Simplex Virus, Type 2 Vaccine': '60',
  'Haemophilus Influenzae Type B Vaccine, Prp-D Conjugate': '46',
  'Haemophilus Influenzae Type B Vaccine, Hboc Conjugate': '47',
  'Haemophilus Influenzae Type B Vaccine, Prp-T Conjugate': '48',
  'Haemophilus Influenzae Type B Vaccine, Prp-Omp Conjugate': '49',
  'Haemophilus Influenzae Type B Vaccine, Conjugate Unspecified Formulation':
    '17',
  'Haemophilus Influenzae Type B Conjugate And Hepatitis B Vaccine': '51',
  'Human Immunodeficiency Virus Vaccine': '61',
  'Human Papilloma Virus Vaccine, Bivalent': '118',
  'Human Papilloma Virus Vaccine, Quadrivalent': '62',
  'Immune Globulin, Intramuscular': '86',
  'Immune Globulin, Intravenous': '87',
  'Immune Globulin, Unspecified Formulation': '14',

  'Influenza Virus Vaccine, Live, Attenuated, For Intranasal Use': '111',
  'Influenza Virus Vaccine, Split Virus (Incl. Purified Surface Antigen)-Retired Code':
    '15',
  'Influenza Virus Vaccine, Whole Virus': '16',
  'Influenza Virus Vaccine, Unspecified Formulation': '88',
  'Influenza Virus Vaccine, H5N1, A/Vietnam/1203/2004 (National Stockpile)':
    '123',
  'Poliovirus Vaccine, Inactivated': '10',
  'Trivalent Poliovirus Vaccine, Live, Oral': '2',
  'Poliovirus Vaccine, Unspecified Formulation': '89',
  'Japanese Encephalitis Vaccine Sc': '39',
  'Junin Virus Vaccine': '63',
  'Leishmaniasis Vaccine': '64',

  'Leprosy Vaccine': '65',
  'Lyme Disease Vaccine': '66',
  'Measles, Mumps And Rubella Virus Vaccine': '3',
  'Measles And Rubella Virus Vaccine': '4',
  'Measles, Mumps, Rubella, And Varicella Virus Vaccine': '94',
  'Malaria Vaccine': '67',
  'Measles Virus Vaccine': '5',
  'Melanoma Vaccine': '68',
  'Meningococcal Polysaccharide Vaccine (Mpsv4)': '32',
  'Meningococcal C Conjugate Vaccine': '103',
  'Meningococcal Polysaccharide (Groups A, C, Y And W-135) Diphtheria Toxoid Conjugate Vaccine (Mcv4P)':
    '114',
  'Meningococcal Acwy Vaccine, Unspecified Formulation': '108',
  'Mumps Virus Vaccine': '7',
  'Parainfluenza-3 Virus Vaccine': '69',
  'Pertussis Vaccine': '11',
  'Plague Vaccine': '23',
  'Pneumococcal Polysaccharide Vaccine, 23 Valent': '33',
  'Pneumococcal Conjugate Vaccine, 7 Valent': '100',
  'Pneumococcal Vaccine, Unspecified Formulation': '109',
  'Q Fever Vaccine': '70',
  'Rabies Vaccine, For Intramuscular Injection Retired Code': '18',
  'Rabies Vaccine, For Intradermal Injection': '40',
  'Rabies Vaccine, Unspecified Formulation': '90',
  'Rheumatic Fever Vaccine': '72',
  'Rift Valley Fever Vaccine': '73',
  'Rabies Immune Globulin': '34',
  'Rotavirus, Live, Monovalent Vaccine': '119',
  'Rotavirus Vaccine, Unspecified Formulation': '122',
  'Rotavirus, Live, Pentavalent Vaccine': '116',
  'Rotavirus, Live, Tetravalent Vaccine': '74',
  'Respiratory Syncytial Virus Immune Globulin, Intravenous': '71',
  'Respiratory Syncytial Virus Monoclonal Antibody (Palivizumab), Intramuscular':
    '93',
  'Rubella Virus Vaccine': '6',
  'Rubella And Mumps Virus Vaccine': '38',
  'Staphylococcus Bacteriophage Lysate': '76',
  'Tetanus And Diphtheria Toxoids, Adsorbed, Preservative Free, For Adult Use (5 Lf Of Tetanus Toxoid And 2 Lf Of Diphtheria Toxoid)':
    '113',
  'Tetanus And Diphtheria Toxoids, Adsorbed, Preservative Free, For Adult Use (2 Lf Of Tetanus Toxoid And 2 Lf Of Diphtheria Toxoid)':
    '9',
  'Tetanus Toxoid, Reduced Diphtheria Toxoid, And Acellular Pertussis Vaccine, Adsorbed':
    '115',
  'Tetanus Toxoid, Adsorbed': '35',
  'Tetanus Toxoid, Unspecified Formulation': '112',
  'Tick-Borne Encephalitis Vaccine': '77',
  'Tuberculin Skin Test; Old Tuberculin, Multipuncture Device': '95',
  'Tuberculin Skin Test; Purified Protein Derivative Solution, Intradermal':
    '96',
  'Tuberculin Skin Test; Purified Protein Derivative, Multipuncture Device':
    '97',
  'Tuberculin Skin Test; Unspecified Formulation': '98',
  'Tularemia Vaccine': '78',
  'Typhoid Vaccine, Unspecified Formulation': '91',
  'Typhoid Vaccine, Live, Oral': '25',
  'Typhoid Vaccine, Parenteral, Other Than Acetone-Killed, Dried': '41',
  'Typhoid Vaccine, Parenteral, Acetone-Killed, Dried (U.S. Military)': '53',
  'Typhoid Vi Capsular Polysaccharide Vaccine': '101',
  'Vaccinia (Smallpox) Vaccine': '75',
  'Vaccinia (Smallpox) Vaccine, Diluted': '105',
  'Vaccinia Immune Globulin': '79',
  'Varicella Virus Vaccine': '21',
  'Venezuelan Equine Encephalitis, Inactivated': '81',
  'Venezuelan Equine Encephalitis, Live, Attenuated': '80',
  'Venezuelan Equine Encephalitis Vaccine, Unspecified Formulation': '92',
  'Varicella Zoster Immune Globulin': '36',
  'Varicella Zoster Immune Globulin (Investigational New Drug)': '117',
  'Yellow Fever Vaccine': '37',
  'Zoster Vaccine, Live': '121',
  'No Vaccine Administered': '998',
  'Unknown Vaccine Or Immune Globulin': '999',
  // 99	Reserved - Do Not Use
  'Pneumococcal Conjugate Vaccine, 13 Valent': '133',
  'Japanese Encephalitis Vaccine For Intramuscular Administration': '134',
  'Hpv, Unspecified Formulation': '137',
  'Meningococcal Oligosaccharide (Groups A, C, Y And W-135) Diphtheria Toxoid Conjugate Vaccine (Mcv4O)':
    ' 136',
  'Influenza, High Dose Seasonal, Preservative-Free': '135',
  'Historical Record Of A Typhus Vaccination': ' 131',
  'Historical Diphtheria And Tetanus Toxoids And Acellular Pertussis, Poliovirus, Haemophilus B Conjugate And Hepatitis B (Recombinant) Vaccine':
    ' 132',
  'Novel Influenza-H1N1-09, All Formulations': '128',

  'Novel Influenza-H1N1-09, Live Virus For Nasal Administration': '125',
  'Novel Influenza-H1N1-09, Preservative-Free, Injectable': '126',
  'Novel Influenza-H1N1-09, Injectable': '127',
  'Tetanus And Diphtheria Toxoids, Not Adsorbed, For Adult Use': '138',
  'Td(Adult) Unspecified Formulation': '139',
  'Influenza, Seasonal, Injectable, Preservative Free': '140',
  'Japanese Encephalitis Vaccine, Unspecified Formulation': '129',
  'Influenza, Seasonal, Injectable': '141',
  'Tetanus Toxoid, Not Adsorbed': '142',
  'Adenovirus, Type 4 And Type 7, Live, Oral': '143',
  'Seasonal Influenza, Intradermal, Preservative Free': '144',
  'Respiratory Syncytial Virus Monoclonal Antibody (Motavizumab), Intramuscular':
    '145',
  'Diphtheria And Tetanus Toxoids And Acellular Pertussis Adsorbed, Inactivated Poliovirus, Haemophilus B Conjugate (Meningococcal Protein Conjugate), And Hepatitis B (Recombinant) Vaccine':
    '146',
  'Meningococcal, Mcv4, Unspecified Conjugate Formulation(Groups A, C, Y And W-135)':
    '147',
  'Meningococcal Groups C And Y And Haemophilus B Tetanus Toxoid Conjugate Vaccine':
    '148',
  'Influenza, Live, Intranasal, Quadrivalent': '149',
  'Influenza, Injectable, Quadrivalent, Preservative Free': '150',
  'Influenza Nasal, Unspecified Formulation': '151',
  'Pneumococcal Conjugate, Unspecified Formulation': '152',
  'Influenza, Injectable, Madin Darby Canine Kidney, Preservative Free': '153',
  'Hepatitis A Immune Globulin': '154',
  'Seasonal, Trivalent, Recombinant, Injectable Influenza Vaccine, Preservative Free':
    '155',
  'Rho(D) Immune Globulin- Iv Or Im': '156',
  'Rho(D) Immune Globulin - Im': '157',
  'Influenza, Injectable, Quadrivalent, Contains Preservative': '158',
  'Rho(D) Unspecified Formulation': '159',
  'Influenza A Monovalent (H5N1), Adjuvanted, National Stockpile 2013': '160',
  'As03 Adjuvant': '801',
  'Influenza, Injectable,Quadrivalent, Preservative Free, Pediatric': '161',
  'Meningococcal B Vaccine, Fully Recombinant': '162',
  'Meningococcal B Vaccine, Recombinant, Omv, Adjuvanted': '163',
  'Meningococcal B, Unspecified Formulation': '164',
  'Human Papillomavirus 9-Valent Vaccine': '165',
  'Influenza, Intradermal, Quadrivalent, Preservative Free, Injectable': '166',
  'Meningococcal Vaccine Of Unknown Formulation And Unknown Serogroups': '167',
  'Seasonal Trivalent Influenza Vaccine, Adjuvanted, Preservative Free': '168',
  'Hep A, Live Attenuated-Im': '169',
  'Non-Us Diphtheria, Tetanus Toxoids And Acellular Pertussis Vaccine, Haemophilus Influenzae Type B Conjugate, And Poliovirus Vaccine, Inactivated (Dtap-Hib-Ipv)':
    '170',
  'Influenza, Injectable, Madin Darby Canine Kidney, Preservative Free, Quadrivalent':
    '171',
  'Cholera, Wc-Rbs': '172',
  'Cholera, Bivwc': '173',
  '	Cholera, Live Attenuated': '174',
  'Human Rabies Vaccine From Human Diploid Cell Culture': '175',
  'Human Rabies Vaccine From Chicken Fibroblast Culture': '176',
  '	Pneumococcal Conjugate Vaccine, 10 Valent': '177',
  'Non-Us Bivalent Oral Polio Vaccine (Types 1 And 3)': '178',
  'Non-Us Monovalent Oral Polio Vaccine, Unspecified Formulation': '179',
  'Tetanus Immune Globulin': '180',
  'Anthrax Immune Globulin': '181',
  'Oral Polio Vaccine, Unspecified Formulation': '182',
  'Yellow Fever Vaccine Alternative Formulation': '183',
  'Yellow Fever Vaccine, Unspecified Formulation': '184',
  'Seasonal, Quadrivalent, Recombinant, Injectable Influenza Vaccine, Preservative Free':
    '185',
  'Influenza, Injectable, Madin Darby Canine Kidney, Quadrivalent With Preservative':
    '186',
  'Zoster Vaccine Recombinant': '187',
  'Zoster Vaccine, Unspecified Formulation': '188',
  'Hepatitis B Vaccine (Recombinant), Cpg Adjuvanted': '189',
  'Typhoid Conjugate Vaccine (Non-Us)': '190',
  'Meningococcal A Polysaccharide Vaccine (Non-Us)': '191',
  'Meningococcal Ac Polysaccharide Vaccine (Non-Us)': '192',
  'Hepatitis A And Hepatitis B Vaccine, Pediatric/Adolescent (Non-Us)': '193',
  'Influenza, Southern Hemisphere, Unspecified Formulation': '194',
  'Diphtheria, Tetanus, Poliomyelitis Adsorbed': '195',
  'Tetanus And Diphtheria Toxoids, Adsorbed, Preservative Free, For Adult Use, Lf Unspecified':
    '196',
  'Influenza, High-Dose Seasonal, Quadrivalent, .7Ml Dose, Preservative Free':
    '197',
  'Influenza, Seasonal, Southern Hemisphere, Quadrivalent, Pediatric 0.25Ml Dose, Preservative Free':
    '200',
  'Influenza, Seasonal, Southern Hemisphere, Quadrivalent, 0.5Ml Dose, No Preservative':
    '201',
  'Influenza, Seasonal, Southern Hemisphere, Quadrivalent, 0.5Ml Dose, With Preservative':
    '202',
  'Diphtheria, Pertussis, Tetanus, Hepatitis B, Haemophilus Influenza Type B, (Pentavalent)':
    '198',
  'Meningococcal Polysaccharide (Groups A, C, Y, W-135) Tetanus Toxoid Conjugate Vaccine .5Ml Dose, Preservative Free':
    '203',
  'Influenza, Seasonal Vaccine, Quadrivalent, Adjuvanted, .5Ml Dose, Preservative Free':
    '205',
  'Smallpox Monkeypox Vaccine, Live Attenuated, Preservative Free (National Stockpile)':
    '206',
  'SARS-COV-2 (COVID-19) vaccine, mRNA, spike protein, LNP, preservative free, 100 mcg/0.5mL dose':
    '207',
  'SARS-COV-2 (COVID-19) vaccine, mRNA, spike protein, LNP, preservative free, 30 mcg/0.3mL dose':
    '208',
  'SARS-COV-2 (COVID-19) vaccine, UNSPECIFIED': '213',
  'SARS-COV-2 (COVID-19) vaccine, vector non-replicating, recombinant spike protein-ChAdOx1, preservative free, 0.5 mL':
    '210',
  'SARS-COV-2 (COVID-19) vaccine, vector non-replicating, recombinant spike protein-Ad26, preservative free, 0.5 ml':
    '212',
  'Ebola Zaire vaccine, live, recombinant, 1mL dose': '204',
  'Ebola, unspecified': '214',
  'SARS-COV-2 (COVID-19) vaccine, Subunit, recombinant spike protein-nanoparticle+Matrix-M1 Adjuvant, preservative free, 0.5mL per dose':
    '211',
  Agrippal: 'AGRPAL',
  Avaxim: 'AVAXM',
  BCG: 'BCG',
  CDT: 'CDT',
  COMVAX: 'CMX',
  'Triple Antigen': 'DTP',
  DTPa: 'DTPA',
  'Engerix B': 'ENGP',
  Fluarix: 'FLRIX',
  Fluvax: 'FLUVAX',
  Fluvirin: 'FLVRN',
  'Fluvax Junior': 'FVXJNR',
  Diphtheria: 'GNDIP',
  Influenza: 'GNFLU',
  'Hepatitis B': 'GNHEP',
  HIB: 'GNHIB',
  'Hepatitis A': 'GNHPA',
  'Japanese Encephalitis': 'GNJEN',
  Measles: 'GNMEA',
  'Meningococcal C': 'GNMEN',
  Mumps: 'GNMUM',
  Pneumococcal: 'GNPNE',
  Polio: 'GNPOL',
  Rotavirus: 'GNROX',
  Rubella: 'GNRUB',
  Tetanus: 'GNTET',
  Varicella: 'GNVAR',
  Twinrix: 'HATWAD',
  'Twinrix Junior': 'HATWNJ',
  'Vaqta Paed/Adol': 'HAVAQ',
  'Havrix Junior': 'HAVJ',
  HibTITER: 'HBOC',
  HBV: 'HBV',
  'HBVAX II': 'HBVP',
  Hiberix: 'HBX',
  'Infanrix Hexa': 'IFHX',
  'Infanrix-IPV': 'IFIP',
  'Infanrix Penta': 'IFPA',
  Infanrix: 'IFX',
  'Infanrix HepB': 'IFXB',
  Influvac: 'INFLUV',
  IPOL: 'IPV',
  'JE-VAX': 'JEVAX',
  Menjugate: 'MENJUG',
  Meningitec: 'MENTEC',
  Menomune: 'MENUME',
  'Mencevax ACWY': 'MENVAX',
  MMR: 'MMR',
  'MMR II': 'MMRCSL',
  Priorix: 'MMRSKB',
  Menitorix: 'MNTRX',
  'NeisVac-C': 'NEISVC',
  Pertussis: 'P',
  Panvax: 'PANVAX',
  Pediacel: 'PDCL',
  Poliacel: 'PLCL',
  Pneumovax: 'PNEUMO',
  ProHIBit: 'PRPD',
  ProQuad: 'PROQAD',
  PedvaxHIB: 'PRPOMP',
  ActHIB: 'PRPT',
  'Prevenar 7': 'PRVNR',
  'Prevenar 13': 'PRVTH',
  'Priorix-Tetra': 'PRXTEX',
  Quadracel: 'QDCL',
  Rotarix: 'ROTRIX',
  Rotateq: 'ROTTEQ',
  Synflorix: 'SYNFLX',
  Tripacel: 'TCL',
  Vaxigrip: 'VAXGRP',
  'Vaxigrip Junior': 'VGRJNR',
  Varilrix: 'VLRIX',
  Varivax: 'VRVAX',
};

export const VACCINE_CODE_OPTIONS = Object.keys(VACCINE_CODE_MAP);
